import type { FaireProductEntity } from "../../entity_types/product";

export const p_th3wtwmjwd: FaireProductEntity = {
  token: "p_th3wtwmjwd",
  type: "product",
  name: "candy cane holiday mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/ae13f0d9ba7e64cf4b21c1600bdd8c21e36afb236c1119b9bb7a26454b4284a8.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    '\n\nA mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty (and easy!) presentation.\n\n\nDetails:\n\n\n\n- single card + envelope\n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:08.876Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
